<template>
	<div class="ui-ns" @focusout="onFocusOut" tabindex="0">
		<div class="ui-ns__elm" @click="onClick">
			<!-- SELECTED VALUE -->
			<div class="ui-ns__elm-selected">
				<div class="ui-ns__elm-selected-label">
					{{ select }}
				</div>
				<IconChevronDown />
			</div>
		</div>

		<!-- Dropdown -->
		<div v-if="isShow" class="ui-ns__list">
			<div class="ui-ns__list-line"></div>
			<div
				@click="onClickSelect(index)"
				:class="
					select === index
						? 'ui-ns__list-item-select'
						: 'ui-ns__list-item'
				"
				v-for="index in total"
				:key="index"
			>
				{{ index }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";

@Options({
	components: { IconChevronDown },
	props: {
		defaultValue: { type: Number, default: 0 },
		total: { type: Number, default: 10 },
		isDisable: { type: Boolean, default: false },
	},
})
export default class UiNumberSelect extends Vue {
	public defaultValue: number;
	public isDisable: boolean;

	public isShow = false;
	public select = 0;

	public mounted() {
		this.select = this.defaultValue;
	}

	/**
	 * Показываем/скрываем выпадающий список
	 */
	public onClick() {
		if (!this.isDisable) {
			this.isShow = !this.isShow;
		}
	}

	/**
	 * Выбор значения из выпадающего списка
	 * @param item
	 */
	public onClickSelect(item: number) {
		this.isShow = !this.isShow;
		this.select = item;
		this.$emit("selected-value", item);
	}

	/**
	 * Скрываем выпадающий список, если кликнули за его пределами
	 */
	public onFocusOut() {
		setTimeout(() => {
			this.isShow = false;
		}, 200);
	}
}
</script>

<style scoped lang="scss">
.ui-ns {
	user-select: none;
	position: relative;

	&__elm {
		padding: 12px;
		background: rgb(244, 246, 250);
		border-radius: 12px;
	}

	&__elm-selected-label {
		color: rgb(119, 121, 124);
		font-size: 16px;
	}

	&__elm-selected {
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
	}

	&__list {
		position: absolute;
		top: 50px;
		width: 100%;
		padding: 8px 0;
		background: rgb(255, 255, 255);
		border: 1px solid rgb(221, 221, 221);
		border-radius: 12px;
		max-height: 150px;
		overflow-y: auto;
		scrollbar-width: thin;
		z-index: 1;
	}

	&__list-item {
		padding: 6px 12px;
		color: rgb(51, 51, 51);
		cursor: pointer;
	}

	&__list-item:hover {
		background: rgb(225, 225, 225);
		border-radius: 4px;
	}

	&__list-item-select {
		padding: 6px 12px;
		color: rgb(51, 51, 51);
		cursor: pointer;
		background: rgb(234, 234, 234);
		border-radius: 4px;
	}
}
</style>
